import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { actionCreators } from "../../Redux";
import ApiCall from "../../Api/ApiCall";
import { AuthEndPoints } from "../../Api/Endpoints";
import Cookies from "js-cookie";

const useVerifyUser = (setmainLoader) => {
  const dispatch = useDispatch();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const handleAuthenticateUser = async () => {
      const isLoggedIn = Cookies.get("isLoggedIn");
      
      if (isLoggedIn !== "true") {
        dispatch(actionCreators.addAuthenticateUser(null));
        setIsVerifying(false);
        setmainLoader(false);
        return;
      }

      try {
        const res = await ApiCall("get", AuthEndPoints.verifyUser);
        if (res?.success) {
          dispatch(actionCreators.addAuthenticateUser(res.result));
          dispatch(actionCreators.userHasSocieties(res.result.userAccessibleSocieties));
          dispatch(actionCreators.userHasRoleWithPermission(res.result.userAccessibleSocieties));
        }
      } catch (error) {
        dispatch(actionCreators.addAuthenticateUser(null));
        dispatch(actionCreators.userHasSocieties([]));
        dispatch(actionCreators.userHasRoleWithPermission([]));
      } finally {
        setIsVerifying(false);
        setmainLoader(false);
      }
    };

    handleAuthenticateUser();
  }, [dispatch, setmainLoader]);

  return isVerifying;
};

export default useVerifyUser;
